module.exports = __webpack_public_path__ + "img/IMG_6985.c17ef353.webp";